import React, {useState} from 'react';
import {Pressable, StyleSheet, View} from 'react-native';
import {observer} from 'mobx-react-lite';

import {useStores} from '../../stores/use-stores';
import theme from '../../style/theme';
import TextInputModal from '../TextInputModal';
import Text from '../ui-controls/Text';
import CheckboxComponent from '../ui-controls/web/CheckBox';

const NominatedPerson = observer(() => {
  const {cartStore} = useStores();

  const [nominatedPersonModalVisible, setNominatedPersonModalVisible] =
    useState(false);

  const handleBePresent = value => {
    cartStore.setWillBePresent(value);
    cartStore.setHasNominatedPerson(!value);
  };

  const handleSomeoneElse = value => {
    cartStore.setHasNominatedPerson(value);
    cartStore.setWillBePresent(!value);
  };

  const saveNominatedPerson = value => {
    cartStore.setNominatedPersonName(value);
    setNominatedPersonModalVisible(false);
  };

  return (
    <View style={styles.section}>
      <Text style={styles.label}>
        Please select who will be accepting the order
      </Text>
      <View style={styles.checkboxContainer}>
        <CheckboxComponent
          boxType="square"
          disabled={false}
          checked={!!cartStore.willBePresent}
          onChange={handleBePresent}
          style={styles.checkbox}
          lineWidth={1}
        />
        <Pressable
          onPress={() => handleBePresent(!cartStore.willBePresent)}
          style={styles.pressableLabel}>
          <Text style={styles.checkboxLabel}>
            I will be at the delivery address to accept the order.
          </Text>
        </Pressable>
      </View>
      <View style={styles.checkboxContainer}>
        <CheckboxComponent
          boxType="square"
          disabled={false}
          checked={!!cartStore.hasNominatedPerson}
          onChange={handleSomeoneElse}
          style={styles.checkbox}
          lineWidth={1}
        />
        <Pressable
          onPress={() => handleSomeoneElse(!cartStore.hasNominatedPerson)}
          style={styles.pressableLabel}>
          <Text style={styles.checkboxLabel}>
            Another person (18+) will be at the delivery address to accept the
            order.
          </Text>
        </Pressable>
      </View>
      {!!cartStore.hasNominatedPerson && (
        <TextInputModal
          isVisible={nominatedPersonModalVisible}
          title="Person receiving order"
          saveAction={saveNominatedPerson}
          saveText="SAVE NAME"
          closeAction={() => setNominatedPersonModalVisible(false)}
          openAction={() => setNominatedPersonModalVisible(true)}
          initialValue={cartStore.nominatedPersonName}
          placeholder="Add name of person accepting delivery"
        />
      )}
    </View>
  );
});

export default NominatedPerson;

const styles = StyleSheet.create({
  label: {
    color: 'grey',
    fontSize: 12,
    marginBottom: 4,
  },
  pressableLabel: {
    marginLeft: 8,
    flex: 1,
  },
  section: {
    marginTop: 8,
  },
  checkboxContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8,
  },
  checkboxLabel: {
    color: theme.colour.text.heading.primary,
  },
  checkbox: {
    alignSelf: 'center',
  },
});
